import { React } from '../../react';

export const DateText = ({ date }: { date: number }) => (
  <span>{new Date(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
);

export const DateTimeText = ({ date }: { date: number }) => (
  <span>{new Date(date).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })},
        {new Date(date).toLocaleTimeString('nl-NL', {hour: '2-digit', minute:'2-digit'})}
  </span>
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/shared/date/index.tsx